export default {
  list: {
    title: "Водители",
    newDriver: "Новый водитель",
    scope: { recruiter: "Мои водители", branch_manager: "Водители филиала", owner: "Все водители" },
    filters: { stageMonth: "Этап за месяц", stageAdded: "Добавлен", month: "Месяц",
      driverType: "Тип водителя",
      freight: "Тип грузов",
      source: "Источник",
      state: "Штат",
      cdlClass: "Класс CDL",
      classN: "Класс {{cls}}",
      dateAdded: "Дата добавления",
      recruiter: "Рекрутер",
      allRecruiters: "Все рекрутеры",
      legalStatus: "Правовой статус",
      problem: "Проблема",
    },
    dateAdded: {
      today: "Сегодня",
      d7: "Последние 7 дней",
      d30: "Последние 30 дней",
      d90: "Последние 90 дней",
      d180: "Последние 180 дней",
      y1: "Последний 1 год",
      older90d: "Ранее 90 дней назад",
      older180d: "Ранее 180 дней назад",
      older1y: "Ранее 1 года назад",
      custom: "Свой период (С – По)…",
      from: "С",
      to: "По",
    },
    problem: { any: "Любая проблема", incomplete: "Профиль не заполнен", docs_missing: "Нет обязательных документов", docs_expiring: "Документы скоро истекают", docs_expired: "Документы просрочены", overdue_reminder: "Просроченное напоминание", no_contact: "Давно нет контакта", stale: "Застрял на этапе", unassigned: "Без рекрутера" },
    search: "Поиск:",
    chips: { all: "Все", lost: "Потеряны" },
    empty: {
      filteredTitle: "Нет водителей по этим фильтрам",
      filteredHint: "Снимите фильтр или поищите по телефону.",
      title: "Водителей пока нет",
      hint: "Добавьте первого водителя или импортируйте Google Sheets.",
    },
    selectAll: "Выбрать все",
    selectOne: "Выбрать {{name}}",
    cols: {
      carrier: "Перевозчик",
      name: "Имя",
      phone: "Телефон",
      state: "Штат",
      cdl: "CDL / опыт",
      status: "Статус",
      source: "Источник",
      owner: "Владелец",
      lastContact: "Последний контакт",
      nextAction: "Следующий шаг",
    },
    pool: "Пул",
    pagLabel: "водителей",
    next: {
      reason: "Причина: {{reason}}",
      firstCall: "Первый звонок",
      waitingCarrier: "Ожидание перевозчика",
      overdueToday: "{{label}} · просрочено сегодня",
      overdueDays_one: "{{label}} · просрочено на {{count}} день",
      overdueDays_few: "{{label}} · просрочено на {{count}} дня",
      overdueDays_many: "{{label}} · просрочено на {{count}} дней",
      overdueDays_other: "{{label}} · просрочено на {{count}} дней",
    },
  },
  statusModal: {
    title: "Изменить статус",
    now: "{{name}} · сейчас {{status}}",
    newStatus: "Новый статус",
    select: "Выберите…",
    pipeline: "Воронка",
    lost: "Потеряны",
    current: "(текущий)",
    job: "Вакансия / перевозчик",
    jobHint: "Показаны только открытые вакансии.",
    docsMissing: "Ещё нет документов: {{names}}.",
    docsBlocked: "Отправка заблокирована, пока их не загрузят (Настройки → Документы).",
    loading: "Загрузка…",
    startDate: "Дата начала",
    reason: "Причина",
    note: "Заметка",
    notePlaceholderHired: "Подтверждение: перевозчик подтвердил по email, ориентация пройдена…",
    optional: "Необязательно",
    hiredNote: "Hired засчитывается после одобрения менеджера (Approvals).",
    submittedNote: "Для выбранной вакансии создаётся заявка и записывается в историю водителя.",
    errors: {
      chooseStatus: "Выберите статус.",
      jobRequired: "Вакансия / перевозчик обязательны.",
      chooseJob: "Выберите вакансию (перевозчика).",
      startDate: "Дата начала обязательна.",
      reason: "Причина обязательна.",
    },
    updated: "Статус обновлён",
    changedBy: "Изменил(а) {{who}}. Обновлено.",
    someoneElse: "другой пользователь",
    reloadedHint: "Проверьте текущее состояние и попробуйте снова.",
    failed: "Не удалось изменить статус",
  },
  form: {
    contact: "Контакты",
    firstName: "Имя",
    lastName: "Фамилия",
    phone: "Телефон",
    noPhoneWarning: "Телефон не указан — звонки и проверка дублей не будут работать.",
    driverType: "Тип водителя",
    freight: "Тип грузов",
    phoneHint: "Любой формат, например (555) 010-0142",
    email: "Email",
    state: "Штат",
    select: "Выберите…",
    city: "Город",
    secondaryPhone: "Дополнительный телефон",
    legalStatus: "Правовой статус",
    dob: "Дата рождения",
    dobHint: "Рекрутерам показывается скрытой",
    cdlMedical: "CDL и медкарта",
    cdlClass: "Класс CDL",
    cdlState: "Штат CDL",
    cdlNumber: "Номер CDL",
    cdlNumberHint: "Также проверяется на дубликаты",
    cdlNumberPlaceholder: "напр. 12345678",
    managedByManager: "Управляется вашим менеджером",
    cdlExpires: "Срок CDL",
    medicalExpires: "Срок медкарты",
    endorsements: "Допуски",
    experienceTitle: "Опыт и предпочтения",
    experience: "Опыт",
    years: "лет",
    months: "мес.",
    drivingType: "Тип вождения",
    equipment: "Техника",
    homeTime: "Дом",
    desiredPay: "Желаемая оплата",
    desiredPayPlaceholder: "$1,400 / неделя",
    availableFrom: "Готов с",
    sourceTitle: "Источник",
    source: "Источник",
    referredBy: "Кто рекомендовал",
    referredByPlaceholder: "Только для Referral",
    owner: "Владелец",
    ownerHint: "Пусто = пул филиала, назначает менеджер",
    pool: "Пул филиала (не назначен)",
    notes: "Заметки",
    notesPlaceholder: "Заметки первого звонка, предпочтения...",
    validation: {
      required: "Обязательно",
      phone: "Введите корректный номер телефона",
      email: "Введите корректный email",
      years: "0–40",
      months: "0–11",
      duplicate: "Уже есть в базе",
    },
  },
  dup: {
    phoneSecondary: "Второй телефон",
    email: "Email",
    sameName_one: "В базе уже есть {{count}} водитель с таким именем:",
    sameName_few: "В базе уже есть {{count}} водителя с таким именем:",
    sameName_many: "В базе уже есть {{count}} водителей с таким именем:",
    sameName_other: "В базе уже есть {{count}} водителя с таким именем:",
    scamShort: "⚠ SCAM с {{date}}",
    confirm: "Это другой человек — всё равно добавить",
    scam: "⚠ SCAM: этот водитель отмечен как мошенник {{date}}.",
    scamBy: "Отметил(а): {{name}}",
    lost: "{{status}} — {{date}} · причина: {{reason}}.",
    reopenHint: "Откройте профиль и верните его в «{{a}}» или «{{b}}» — история сохранится.",
    title: "Возможный дубликат.",
    phone: "Телефон {{phone}}",
    cdl: "Номер CDL",
    belongsTo: "принадлежит",
    owner: "владелец {{name}}",
    unassigned: "не назначен (пул)",
    assignedUntil: "назначен до {{date}}",
    open: "Открыть профиль",
    askTransfer: "Попросить менеджера передать",
  },
  new: {
    breadcrumb: "Водители",
    title: "Новый водитель",
    added: "Водитель добавлен",
    addedDesc: "{{name}} теперь в статусе New.",
    checkFields: "Проверьте выделенные поля",
    saveFailed: "Не удалось сохранить водителя",
    transferNote: "Найден дубликат при добавлении водителя",
    requestSent: "Запрос отправлен вашему менеджеру",
    requestSentDesc: "Вы получите уведомление о решении.",
    requestFailed: "Не удалось отправить запрос",
    you: "вы",
    selectedRecruiter: "выбранный рекрутер",
    pool: "пул филиала (не назначен)",
    ownerAfter: "После сохранения владелец:",
    assignedFor: "назначен на {{days}} дней (до {{until}})",
    required: "обязательно",
    save: "Сохранить водителя",
  },
  profile: {
    noPhone: "Нет телефона",
    tabs: {
      overview: "Обзор",
      applications: "Заявки ({{n}})",
      activity: "Активность ({{n}})",
      documents: "Документы {{n}}/{{total}}",
      history: "История",
    },
    approvedBy: "одобрил(а) {{name}}",
    manager: "менеджер",
    pendingApproval: "ожидает одобрения менеджера",
    source: "Источник: {{source}}",
    owner: "Владелец:",
    pool: "пул филиала (не назначен)",
    assignedUntil: "назначен до {{date}}",
    added: "добавлен {{date}}",
    submitToJob: "Подать на вакансию",
    logCall: "Записать звонок",
    changeStatus: "Изменить статус",
    hero: { call: "Звонок", note: "Заметка", moveTo: "Дальше: {{stage}}", more: "Другие действия" },
    nextStep: { title: "Следующий шаг", overdue: "просрочено", markDone: "Выполнено", none: "Следующего шага нет. Добавьте напоминание, чтобы не потерять водителя." },
    stageBar: { label: "Этап", hint: "Перетащите ползунок или нажмите на этап — водитель перейдёт туда", notAllowed: "Из текущего этапа недоступно", saving: "Сохранение…" },
    daysInStage_one: "{{count}} день на этапе",
    daysInStage_few: "{{count}} дня на этапе",
    daysInStage_many: "{{count}} дней на этапе",
    daysInStage_other: "{{count}} дня на этапе",
    applications: "Заявки ({{n}})",
    details: {
      phone: "Телефон",
      email: "Email",
      owner: "Владелец",
      added: "Добавлен",
      driverType: "Тип водителя",
      freight: "Тип грузов",
      title: "Данные водителя",
      fullName: "Полное имя",
      dob: "Дата рождения",
      cdl: "CDL",
      classN: "Класс {{cls}}",
      hideCdl: "Скрыть номер CDL",
      showCdl: "Показать номер CDL",
      cdlExpires: "Срок CDL",
      medicalExpires: "Срок медкарты",
      expired: "⚠ истёк {{days}} дн. назад",
      expiresIn: "⚠ через {{days}} дн.",
      experience: "Опыт",
      year_one: "{{count}} год",
      year_few: "{{count}} года",
      year_many: "{{count}} лет",
      year_other: "{{count}} лет",
      endorsements: "Допуски",
      equipment: "Техника",
      preferences: "Предпочтения",
      home: "Дом {{value}}",
      availableFrom: "Готов с",
      secondaryPhone: "Дополнительный телефон",
      legalStatus: "Правовой статус",
      referredBy: "Кто рекомендовал",
      notes: "Заметки",
      importedFrom: "Импортирован из",
    },
    retention: {
      title: "Удержание",
      subtitle: "{{job}} · {{carrier}} · старт {{date}}",
      confirmedChip: "{{days}} дней · {{date}}",
      confirmed: "Удержание {{days}} дней подтверждено",
      confirm: "Подтвердить {{days}} дней",
      due: "срок {{date}}",
      dueTitle: "Срок {{date}}",
    },
    apps: {
      payment: "Оплата",
      empty: "Заявок пока нет. Подайте водителя на вакансию.",
      job: "Вакансия",
      carrier: "Перевозчик",
      status: "Статус",
      date: "Дата",
      submitted: "Подана",
      by: "Кем",
      reply: "Ответ перевозчика",
      decided: "Решение",
      rejected: "Отклонён · {{reason}}",
      start: "старт {{date}}",
    },
    activity: {
      title: "Активность",
      addReminder: "Добавить напоминание",
      type: "Тип активности",
      types: { note: "Заметка", call: "Звонок", sms: "SMS", email: "Email", status: "Статус", system: "Система" },
      system: "Система",
      created: "Создан",
      callMins: "Звонок, {{mins}} мин",
      min: "мин",
      duration: "Длительность, минуты",
      outcome: "Результат",
      outcomes: { answered: "Ответил", no_answer: "Нет ответа", voicemail: "Голосовая почта", busy: "Занято" },
      placeholderCall: "Как прошёл звонок?",
      placeholderNote: "Добавьте заметку или запишите звонок...",
      callLogged: "Звонок записан",
      nextReminder: "Следующее напоминание:",
      overdue: "просрочено",
      tomorrow: "Завтра",
      reminderDone: "Напоминание выполнено",
      noPending: "Нет ожидающих напоминаний.",
      loading: "Загрузка активности…",
      empty: "Активности пока нет.",
      emptyTitle: "Активности пока нет",
      showAll: "Показать всю активность ({{n}}) →",
      page: "Страница {{page}} из {{pages}}",
    },
    reminder: {
      title: "Добавить напоминание",
      chooseDateTime: "Выберите дату и время.",
      added: "Напоминание добавлено",
      failed: "Не удалось добавить напоминание",
      type: "Тип",
      date: "Дата",
      time: "Время",
      timeHint: "Время водителя ({{tz}})",
      assignTo: "Назначить",
      driversOwner: "Владелец водителя",
      note: "Заметка",
      notePlaceholder: "Уточнить детали опыта",
    },
    history: { when: "Когда", change: "Изменение", reason: "Причина / заметка", job: "Вакансия", by: "Кем" },
    edit: {
      title: "Редактировать {{name}}",
      desc: "Изменения записываются в журнал аудита.",
      updated: "Водитель обновлён",
      conflictDesc: "Ваши правки не сохранены. Проверьте новые значения и попробуйте снова.",
      checkFields: "Проверьте выделенные поля",
    },
  },
};
